import { useParams } from 'react-router-dom';
import { FORMATION_KINDS, formationKindType } from '../../types';
import { FormationInitialeEntryTable } from './FormationInitialeEntryTable';
import { FormationContinueEntryTable } from './FormationContinueEntryTable';

function FormationEntries() {
    const params = useParams();

    const kind = params.kind as formationKindType;

    if (!kind || FORMATION_KINDS.includes(kind) === false) {
        return <div>Invalid formation kind: {params.kind}</div>;
    }

    return <div>{renderTable(kind)}</div>;

    function renderTable(kind: formationKindType) {
        switch (kind) {
            case 'formation-initiale':
                return <FormationInitialeEntryTable />;
            case 'formation-continue':
                return <FormationContinueEntryTable />;
        }
    }
}

export { FormationEntries };
